import React, { useState, useEffect, useMemo } from 'react'
import { Wrapper, BarStrip, ProgressBar, StepperItem } from '../_components'
import Table, { SelectColumnFilter } from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'

const ActionField = ( record ) => {
    return (
      <div onClick={async () => {
        await localStorage.setItem( "link", "display" )
        await localStorage.setItem( "applicationId", record.value )
        return window.location.reload()
      } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`View`}
      </div>
    )
}

const ProgressField = record => {
    return (
      <div className="flex w-full items-center justify-center">
        <ProgressBar value={record.value}/>
        <div className="text-xs mx-2">
            {`${record.value}%`}
        </div>
      </div>
    )
}

const steps = [
  "Pending",
  "Actioned"
]
export default function AllPaymentList( { product } ) {
  const PaymentColumns = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "Registered Name of Applicant",
      accessor: "applicant"
    },
    {
      Header: "Email Address",
      accessor: "email_address"
    },
    {
      Header: "Annual Gross Income(UGX)",
      accessor: "annual_income"
    },
   
  ] )
  
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const [ tag, setTag ] = useState( "Pending" )

  useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading ])

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            progress: result.progress,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            id: result.id
        }
       } ).filter( record => record.stage === "4" )

       setRecords( results )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`Payment List Under Process of IT Service Provider`}
            </div>
            <div className="flex flex-col justify-center w-full bg-white">
              <div className="w-full flex flex-row border-b border-gray-500 rounded-sm">
                {/* tabs */}
                {steps.map( ( item, index ) => {
                  return (
                  <StepperItem 
                    edge={index === 0} 
                    active={tag.toUpperCase() === item?.toUpperCase()} 
                    key={item} 
                    label={item} 
                    onPress={() => {
                      return setTag( item )
                    } } />
                  )
                } )}
              </div>
              <Table 
                label="Application Details"
                columns={PaymentColumns}
                data={records}
              />
            </div>
          </div>
        </div>
    </Wrapper>
  )
}
